import {store} from '../store';

const AuthTokenUtils = {
  decodeJwtPayload(tokenString) {
    if (!tokenString) {return null;}
    const data = tokenString.split('.')[1];
    if (!data) {return null;}
    return JSON.parse(atob(data));
  },

  token() {
    const state = store.getState();
    const {auth: {token}} = state;
    return token;
  },

  tokenData() {
    const token = this.token();
    if (!token) {return null;}
    return this.decodeJwtPayload(token);
  },

  isExpired() {
    try {
      const tokenData = this.tokenData();
      if (tokenData === null) {return true;}
      const time = Math.floor(new Date().getTime() / 1000);
      return time >= tokenData.exp;
    } catch (e) {
      return true;
    }
  },
};
export default AuthTokenUtils;